export function parseBrDatetime(value: string): Date | null {
  const match = value
    .trim()
    .match(/^(\d{2})\/(\d{2})\/(\d{4})\s+(\d{2}):(\d{2})$/);

  if (!match) return null;

  const [, dd, mm, yyyy, hh, min] = match;

  const date = new Date(
    Number(yyyy),
    Number(mm) - 1,
    Number(dd),
    Number(hh),
    Number(min),
    0,
    0,
  );

  if (isNaN(date.getTime())) return null;

  return date;
}

export function validateDates(
  startValue: string,
  endValue: string,
): { startError: string | null; endError: string | null } {
  let startError: string | null = null;
  let endError: string | null = null;

  const now = new Date();

  // Como o componente não retorna segundos, zeramos segundos e milissegundos
  // para comparar tudo no mesmo nível de precisão.
  now.setSeconds(0, 0);

  const startDate = parseBrDatetime(startValue);
  const endDate = parseBrDatetime(endValue);

  if (startValue && startDate === null) {
    startError = 'Data inválida. Use o formato dd/mm/yyyy hh:mm';
  } else if (startDate && startDate <= now) {
    startError = 'O início da vigência deve ser uma data futura (após o momento atual).';
  }

  if (endValue && endDate === null) {
    endError = 'Data inválida. Use o formato dd/mm/yyyy hh:mm';
  } else if (endDate && startDate && endDate <= startDate) {
    endError = 'O fim da vigência deve ser posterior ao início da vigência.';
  } else if (endDate && !startDate && endDate <= now) {
    endError = 'O fim da vigência deve ser uma data futura.';
  }

  return { startError, endError };
}
